var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline" } },
    [
      _c("ModalRecetteEdition", {
        ref: "modalRecetteEdition",
        on: {
          "recette-enregistree": function($event) {
            return _vm.recetteEnregistree($event)
          },
          "recette-enregistree-modifiee": function($event) {
            return _vm.recetteEnregistreeModifiee($event)
          },
          "recette-enregistree-inchangee": function($event) {
            return _vm.recetteEnregistreeInchangee($event)
          },
          mouseleave: function($event) {
            return _vm.cacherApercuRecetteLignes()
          }
        }
      }),
      _vm.recetteId
        ? _c("RecetteListeIngredients", {
            ref: "recetteApercu",
            style:
              "position:absolute;z-index:100;font-family:'Roboto';font-size:11px;line-height:initial;display:" +
              (_vm.apercuRecetteLignes ? "block" : "none"),
            attrs: {
              recette: _vm.recette,
              nomDeRecette: true,
              afficherAllergenes: true
            }
          })
        : _vm._e(),
      _vm.estDeclinaisonNonPersonnalisee
        ? _c("i", {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: { content: "Recette non vérifiée", placement: "top" },
                expression:
                  "{ content: 'Recette non vérifiée', placement: 'top' }"
              }
            ],
            staticClass: "fas fa-exclamation-triangle text-warning",
            staticStyle: { "z-index": "3" }
          })
        : _vm._e(),
      !_vm.estLien
        ? _c(
            "span",
            {
              ref: "nomRecette",
              class: _vm.texteClass,
              staticStyle: {
                cursor: "default",
                position: "relative",
                "z-index": "3"
              },
              on: {
                mouseover: function($event) {
                  return _vm.montrerApercuRecetteLignes()
                },
                mouseleave: function($event) {
                  return _vm.cacherApercuRecetteLignes()
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.recetteNom) + " ")]
          )
        : _c(
            "a",
            {
              ref: "nomRecette",
              class: _vm.texteClass,
              staticStyle: { cursor: "pointer", "z-index": "3" },
              attrs: { href: "" },
              on: {
                mouseover: function($event) {
                  return _vm.montrerApercuRecetteLignes()
                },
                mouseleave: function($event) {
                  return _vm.cacherApercuRecetteLignes()
                },
                click: function($event) {
                  $event.preventDefault()
                  return _vm.ouvrirEditionRecette(_vm.recetteId)
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.recetteNom) + " ")]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }